import { ConstraintTypes } from "../../constants/constraints";

const doesConstraintReferenceItems = (c, itemIds) => {
  return (
    itemIds.indexOf(c.subject) >= 0 || (c.constraintType === ConstraintTypes.Relative && itemIds.indexOf(c.object) >= 0)
  );
};

const getDateConstraintsToBeDeletedWithItems = (globalState, itemIds) => {
  const constraints = globalState.data.dateConstraints.byId
    .filter(c => doesConstraintReferenceItems(c, itemIds))
    .map(c => c.id)
    .toList();
  return constraints;
};

const getDateConstraintIds = state => state.data.dateConstraints.allIds;

const getDateConstraintsById = state => state.data.dateConstraints.byId;

export default {
  getDateConstraintsToBeDeletedWithItems,
  getDateConstraintIds,
  getDateConstraintsById
};
